import * as React from 'react';
import { MergeCodeButtonProps } from 'app/area/codetable/common/merge-code/types';

export const MergeCodeButton = (props: MergeCodeButtonProps) => {

  const { codeItem, mergeCode, metadata, translation, updateMergeCode } = props;

  const handleMergeCodeItem = () => {
    updateMergeCode({
      codetableId: metadata?.codetable?.id,
      codeId: codeItem.id,
      codeDescription: codeItem.description,
      replaceInfoText: metadata?.label,
      showMergeCode: !mergeCode?.showMergeCode
    });
  };

  return <button
    type="button"
    className="dropdown-item"
    onClick={handleMergeCodeItem}>
    {translation?.delete}
  </button>;
};
